import * as React from 'react';
import type { ThemeHolder, ThemeTreeTypeHolder, ThemeType } from 'types/index.d';
import { buildTheme } from '../themeBuilder';
import { defLightTheme } from '../themes/defaultThemes';





const baseTheme = buildTheme(defLightTheme);
export const ThemeContext = React.createContext<ThemeType>(baseTheme);

export class ThemeProvider extends React.Component<{}, ThemeHolder> {

  constructor(props: ThemeTreeTypeHolder) {
    super(props);
    const theme = props.theme || defLightTheme;
    this.state = {
      theme: buildTheme(theme)
    }
  }

  render() {
    return (
      <ThemeContext.Provider value={this.state.theme} >
        {this.props.children}
      </ThemeContext.Provider>
    );
  }

}


//TODO: Work on the wrapper, typescript issues....  Anyone have any suggestions?
// const ThemeWrapper = (ClassRef: React.ReactElement<any>): React.ReactNode =>{

//   const ThemeWrap = (props:{[key:any]:any}):React.ReactNode => {

//     const theme = React.useContext(ThemeContext);

//     const child = React.createElement(ClassRef, Object.assign(props, {theme:theme}));

//     return React.createElement(ClassRef, , child );    
//   }

//   return ThemeWrapper;


